export enum EEntityStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}
